import { getAxiosInstance } from "../../../../api";

export const createUser = async (body) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(`/admin/users/register`, body);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const updateUser = async (body) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(`/admin/users/update`, body);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};